import React, { useEffect, useRef, useState } from "react";
import "./InternalManagement.css";
import Pagination from "../../components/Pagination/Pagination";
import PopUp from "../../components/PopUp/PopUp";
import CheckboxDropDown from "../../components/CheckboxDropDown/CheckboxDropDown";
import { fetchByfilter } from "../../services/GenericAPI";
import {
  fetch_internalmanagementusers,
  fetch_internalMangamentclusters,
} from "../../services/dashboardAPI";
import Search from "../../components/SearchBar/Search";
import NoResultsComponent from "../../components/NoResults/NoResult";
import Loader from "../../components/Loader/Loader";
import Button from "../../components/Button/Button";
import Table from "../../components/Table/Table";
import { useLocation, useNavigate } from "react-router-dom";
import Toast from "../../components/Toast/Toast";
import { deleteClusterApi } from "../../services/api";
import { deleteUserApi } from "../../services/api";
import { useLanguage } from "../../context/Languagecontext";
import { Globals as OldGlobals } from "../../global/Globals";

let paginationPageChange = () => { };

const InternalManagement = ({ selectedTab }) => {
  const { Globals, languages, setLanguages } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();
  const { toastValue, activeTabData } = location.state || '';
  const [clusterUserData, setClusterUserData] = useState(null);
  const [totalCount, setTotalcount] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [enableClearAll, setEnableClearAll] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(false);
  const [searchQuery, setSearchQuery] = useState(null);
  const [activeTab, setActiveTab] = useState(activeTabData || OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT);
  const [dataSorting, setDatasorting] = useState(1);
  const [clusterUserDataStatus, setClusterUserDataStatus] = useState(null);
  const [isClearAllTriggered, setIsClearAllTriggered] = useState(false);
  const [toast, setToast] = useState({ open: false, status: '', title: "" });
  const [Popup, setPopup] = useState({ open: false });
  const [userPopup, setUserPopup] = useState({ open: false });


  const prevSelectedState = useRef({});
  const isInitialRenderPage = useRef(true);
  const isInitialRenderSort = useRef(true);
  const isInitialRenderDropdown = useRef(true);
  const isInitialRenderSearch = useRef(true);
  const isInitialRenderLanguages = useRef(true);

  const [dropdownState, setDropdownState] = useState({
    activeDropdown: null,
    dropdowns: {
      REGION: { options: [], selected: [], selectedText: [], isloading: false },
      GENRE: { options: [], selected: [], selectedText: [], isloading: false },
      CLUSTER: { options: [], selected: [], selectedText: [], isloading: false },
      DESIGNATION: { options: [], selected: [], selectedText: [], isloading: false },
      DATE: {
        selected: [],
        selectedMonthYear: [],
        selectedText: [],
        isDatePicker: true,
        isloading: false,
      },
    },
  });

  const dropdownRefs = useRef({}); // Store refs for dropdowns
  const openPopupuser = (UserID) => {
    const data = {
      open: true,
      title: Globals.DELETE_USER.TITLE,
      promptText: Globals.DELETE_USER.POPUP_MESSAGE,
      negativeActionText: Globals.DELETE_USER.FOOTER_BTN_TITLE,
      UserID: UserID,
      isDisabled: false,
    }
    setUserPopup(data)
  }

  const closePopupuser = () => {
    setUserPopup({ open: false })
  }

  const deleteUser = (id) => {
    deleteUserApi(id)
      .then((response) => {
        if (response.data.status === "OK") {
          closePopupuser();
          renderToast({
            open: true,
            status: "success",
            title: Globals.DELETE_USER.SUCCESS_TOAST,
          });
          onRefresh();
        }
        else {
          renderToast({
            open: true,
            status: "error",
            title: Globals.TOAST_FAILURE,
          });
          closePopupuser();
        }
      })
      .catch((error) => {
        console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
        closePopupuser();
        renderToast({
          open: true,
          status: "error",
          title: Globals.TOAST_FAILURE,
        });
      });
  };

  const openPopup = (popUpType, clusterId) => {
    let data;
    switch (popUpType) {
      case "delete":
        data = {
          open: true,
          title: Globals.DELETE_CLUSTER.TITLE,
          promptText: Globals.DELETE_CLUSTER.POPUP_MESSAGE,
          negativeActionText: Globals.DELETE_CLUSTER.FOOTER_BTN_TITLE,
          clusterId: clusterId,
          isDisabled: false,
        }
        break;
      case "undelete":
        data = {
          open: true,
          title: Globals.DELETE_CLUSTER.TITLE,
          promptText: Globals.DELETE_CLUSTER.POPUP_MESSAGE_UNDELETE,
          negativeActionText: Globals.DELETE_CLUSTER.FOOTER_BTN_TITLE,
          clusterId: clusterId,
          isDisabled: true,
        }
        break;
    }
    setPopup(data)
  }

  const closePopup = () => {
    setPopup({ open: false })
  }

  const deleteCluster = (id) => {
    deleteClusterApi(id)
      .then((response) => {
        switch (response.data.status) {
          case "True":
            closePopup();
            onRefresh()
            renderToast({
              open: true,
              status: "success",
              title: Globals.DELETE_CLUSTER.SUCCESS_TOAST,
            });
            break;
          case "False":
            openPopup("undelete", id);
            break;
          default:
            renderToast({
              open: true,
              status: "error",
              title: Globals.TOAST_FAILURE,
            });
            closePopup();
            break;
        }
      })
      .catch((error) => {
        console.error(Globals.ERROR_MESSAGES.GENERIC_API_ERROR, error);
        closePopup();
        renderToast({
          open: true,
          status: "error",
          title: Globals.TOAST_FAILURE,
        });
      });
  };

  const renderToast = (data) => {
    setToast(data);
    setTimeout(() => {
      setToast({ open: false, status: '', title: '' });
    }, 4000);
  }

  useEffect(() => {
    if (toastValue) renderToast(toastValue)
  }, [toastValue]);

  const onPageChange = (pageNumber, setPage = () => { }) => {
    setCurrentPage(pageNumber);
    paginationPageChange = setPage;
  };

  //OnRefresh Function
  const onRefresh = () => {
    const data = {
      ...(activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? {
          country: dropdownState.dropdowns.REGION.selected,
          genre: dropdownState.dropdowns.GENRE.selected,
        }
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? {}
          : {}), // Ensure an empty object if neither condition matches

      [activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? "createdDate"
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? "registrationDate" : "Date"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    paginationPageChange(1);
    fetchClusterUserData(data, 1, activeTab);
  };

  //handle TabClick
  const handleTabClick = (tab) => {
    setDatasorting(1);
    setClusterUserDataStatus(null);
    setClusterUserData(null);
    setTotalcount(null);
    handleClearAll();
    setDropdownState((prev) => {
      const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
        acc[key] = { ...prev.dropdowns[key], options: [] };
        if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
          acc[key].selectedMonthYear = [];
        }
        return acc;
      }, {});
      return { ...prev, dropdowns: clearedDropdowns };
    });
    setActiveTab(tab);

    const data = {
      ...(tab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? {
          country: dropdownState.dropdowns.REGION.selected,
          genre: dropdownState.dropdowns.GENRE.selected,
        }
        : tab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? {}
          : {}), // Ensure an empty object if neither condition matches

      [tab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? "createdDate"
        : tab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? "registrationDate"
          : "Date"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    paginationPageChange(1);
    fetchClusterUserData(data, 1, tab);
  };

  //FirstTime Data Fetching
  useEffect(() => {
    const data = {
      ...(activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? {
          country: dropdownState.dropdowns.REGION.selected,
          genre: dropdownState.dropdowns.GENRE.selected,
        }
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? {}
          : {}), // Ensure an empty object if neither condition matches

      [activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? "createdDate"
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? "registrationDate"
          : "Date"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    fetchClusterUserData(data, 1, activeTab);
  }, []);

  // Functionality for DropDownchange
  useEffect(() => {
    if (isInitialRenderDropdown.current) {
      isInitialRenderDropdown.current = false;
      prevSelectedState.current = Object.fromEntries(
        Object.entries(dropdownState.dropdowns).map(([key, value]) => [key, value.selected])
      );
      return;
    }

    let hasSelectedChanged = false;

    for (const key of Object.keys(dropdownState.dropdowns)) {
      const currentSelected = dropdownState.dropdowns[key]?.selected || [];
      const prevSelected = prevSelectedState.current[key] || [];

      if (JSON.stringify(currentSelected) !== JSON.stringify(prevSelected)) {
        hasSelectedChanged = true;
        break;
      }
    }

    if (!hasSelectedChanged && !isClearAllTriggered) return;

    const hasSelectedOptions = Object.values(dropdownState.dropdowns).some(
      (dropdown) => dropdown?.selected?.length > 0
    );

    setEnableClearAll(hasSelectedOptions || !!searchQuery);

    const data = {
      ...(activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? {
          country: dropdownState.dropdowns.REGION.selected,
          genre: dropdownState.dropdowns.GENRE.selected,
        }
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? {}
          : {}), // Ensure an empty object if neither condition matches

      [activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? "createdDate"
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? "registrationDate"
          : "Date"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };

    paginationPageChange(1);
    fetchClusterUserData(data, 1, activeTab);
    // Update only selected values in ref
    prevSelectedState.current = Object.fromEntries(
      Object.entries(dropdownState.dropdowns).map(([key, value]) => [key, value.selected])
    );

    if (isClearAllTriggered) setIsClearAllTriggered(false);
  }, [dropdownState, isClearAllTriggered]);

  //Pagination Change
  useEffect(() => {
    if (isInitialRenderPage.current) {
      isInitialRenderPage.current = false;
      return; // Skip on first render
    }
    const data = {
      ...(activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? {
          country: dropdownState.dropdowns.REGION.selected,
          genre: dropdownState.dropdowns.GENRE.selected,
        }
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? {}
          : {}), // Ensure an empty object if neither condition matches

      [activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? "createdDate"
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? "registrationDate"
          : "Date"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    //fetchAllData(data, currentPage, activeTab);
    fetchClusterUserData(data, currentPage, activeTab);
  }, [currentPage]);

  //SearchQuery Change
  useEffect(() => {
    if (isInitialRenderSearch.current) {
      isInitialRenderSearch.current = false;
      return; // Skip on first render
    }
    const data = {
      ...(activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? {
          country: dropdownState.dropdowns.REGION.selected,
          genre: dropdownState.dropdowns.GENRE.selected,
        }
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? {}
          : {}), // Ensure an empty object if neither condition matches

      [activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? "createdDate"
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? "registrationDate"
          : "Date"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    paginationPageChange(1);
    fetchClusterUserData(data, 1, activeTab);
  }, [searchQuery]);

  //Sorting change
  useEffect(() => {
    if (isInitialRenderSort.current) {
      isInitialRenderSort.current = false;
      return; // Skip on first render
    }

    const data = {
      ...(activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? {
          country: dropdownState.dropdowns.REGION.selected,
          genre: dropdownState.dropdowns.GENRE.selected,
        }
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? {}
          : {}), // Ensure an empty object if neither condition matches

      [activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? "createdDate"
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? "registrationDate"
          : "Date"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    fetchClusterUserData(data, currentPage, activeTab);
  }, [dataSorting]);

  async function fetchClusterUserData(filters, pagenumber, activetab) {
    try {
      let responseData;
      if (activetab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT) {
        responseData = await fetch_internalMangamentclusters(filters, pagenumber);
        setClusterUserData(responseData?.data?.content?.internalClusterDetails);
        setClusterUserDataStatus(responseData?.data?.status);
        setTotalcount(responseData?.data?.content?.pageCount);
      } else if (activetab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT) {
        responseData = await fetch_internalmanagementusers(filters, pagenumber);
        setClusterUserData(responseData?.data?.content?.userManagement);
        setClusterUserDataStatus(responseData?.data?.status);
        setTotalcount(responseData?.data?.content?.pageCount);
      }
    } catch (error) {
      console.error("Error in fetching brief info", error);
    }
  }

  const handleClickOutside = (event) => {
    // Check if the click is outside all dropdowns
    const isClickInsideDropdown = Object.values(dropdownRefs.current).some((ref) =>
      ref?.contains(event.target)
    );

    if (!isClickInsideDropdown) {
      setActiveDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handletog = async (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
    paginationPageChange(1);

    if (
      dropdownState.dropdowns[dropdownName]?.options &&
      dropdownState.dropdowns[dropdownName]?.options.length === 0
    ) {
      await fetchOptions(dropdownName);
    }
  };

  const fetchOptions = async (dropdownName) => {
    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: true },
      },
    }));

    try {
      let response;
      let data;
      let filterData;
      if (dropdownName == OldGlobals.INTERNAL_MANAGEMENT.REGIONS) {
        response = await fetchByfilter(OldGlobals.FILTER_OPTIONS_NAME.COUNTRY);
        data = response.data.content;
        filterData = data[OldGlobals.FILTER_OPTIONS_NAME.COUNTRY];
      } else {
        response = await fetchByfilter(OldGlobals.FILTER_OPTIONS_NAME[dropdownName]);
        data = response.data.content;
        filterData = data[OldGlobals.FILTER_OPTIONS_NAME[dropdownName]];
      }
      // Simulate fetching options for each dropdown
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...prev.dropdowns[dropdownName],
            options: [...filterData],
            isLoading: false,
          },
        },
      }));
    } catch (error) {
      console.error("Error fetching options:", error);
      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: { ...prev.dropdowns[dropdownName], isLoading: false },
        },
      }));
    }
  };

  const handleSelectAll = (dropdownName, selectAll, options) => {
    setClusterUserDataStatus(null);
    const selectedDataSting = options.map((option) => String(option.id));
    const selectedDataText = options.map((option) => String(option.name));

    setDropdownState((prev) => ({
      ...prev,
      dropdowns: {
        ...prev.dropdowns,
        [dropdownName]: {
          ...prev.dropdowns[dropdownName],
          selected: selectAll ? selectedDataSting : [],
          selectedText: selectAll ? selectedDataText : [],
        },
      },
    }));
  };

  const handleSelect = (dropdownName, value) => {
    setClusterUserDataStatus(null);
    setDropdownState((prev) => {
      const dropdown = prev.dropdowns[dropdownName];
      if (!dropdown) return prev;
      const isSelected = dropdown.selected.includes(String(value.id));
      const inSelectedText = dropdown.selectedText.includes(String(value.name));

      const newSelected = isSelected
        ? dropdown.selected.filter((item) => item !== String(value.id)).map(String)
        : [...dropdown.selected.filter((item) => item !== String(value.id)), String(value.id)];

      const newSelectedText = inSelectedText
        ? dropdown.selectedText.filter((item) => item !== String(value.name)).map(String)
        : [
          ...dropdown.selectedText.filter((item) => item !== String(value.name)),
          String(value.name),
        ];

      return {
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...dropdown,
            selected: newSelected,
            selectedText: newSelectedText,
          },
        },
      };
    });
  };

  const handleClearAll = () => {
    if (enableClearAll) {
      setCurrentPage(1);
      setClusterUserDataStatus(false);
      setEnableClearAll(false);
      setSearchQuery(null);
      setDropdownState((prev) => {
        const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
          acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [] };
          if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
            acc[key].selectedMonthYear = [];
          }
          return acc;
        }, {});
        return { ...prev, dropdowns: clearedDropdowns };
      });
      setIsClearAllTriggered(true);
    }
  };

  const handleDateChange = (dropdownName, date) => {
    setClusterUserDataStatus(null);
    if (date instanceof Date && !isNaN(date)) {
      const month = date.getMonth() + 1; // Months are 0-based
      const year = date.getFullYear();

      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const MonthName = monthNames[month - 1];

      setDropdownState((prev) => ({
        ...prev,
        dropdowns: {
          ...prev.dropdowns,
          [dropdownName]: {
            ...prev.dropdowns[dropdownName],
            selected: month + "-" + year,
            selectedMonthYear: month + "," + year,
            selectedText: MonthName + "-" + year,
          },
        },
      }));
    }
  };

  const handleSearch = (term) => {
    setSearchQuery(term);
    const dropdownSelected = Object.values(dropdownState?.dropdowns || {}).some(
      (dropdown) => dropdown?.selected?.length > 0
    );
    setClusterUserDataStatus(null);
    setEnableClearAll(term !== "" || dropdownSelected);
  };

  const handleSorting = (sorting) => {
    setDatasorting(sorting);
  };

  const dropdownselected = Object.values(dropdownState?.dropdowns).some(
    (dropdown) => dropdown?.selected && dropdown?.selected.length > 0
  );

  //language change logic
  useEffect(() => {
    if (isInitialRenderLanguages.current) {
      isInitialRenderLanguages.current = false;
      return; // Skip on first render
    }
    setDatasorting(1);
    setDropdownState((prev) => {
      const clearedDropdowns = Object.keys(prev.dropdowns).reduce((acc, key) => {
        acc[key] = { ...prev.dropdowns[key], selected: [], selectedText: [], options: [] };
        if (prev.dropdowns[key].hasOwnProperty("selectedMonthYear")) {
          acc[key].selectedMonthYear = [];
        }
        return acc;
      }, {});
      return { ...prev, dropdowns: clearedDropdowns };
    });

     const data = {
      ...(activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? {
          country: dropdownState.dropdowns.REGION.selected,
          genre: dropdownState.dropdowns.GENRE.selected,
        }
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? {}
          : {}), // Ensure an empty object if neither condition matches

      [activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
        ? "createdDate"
        : activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
          ? "registrationDate"
          : "Date"]:
        dropdownState.dropdowns.DATE.selected.length > 0
          ? dropdownState.dropdowns.DATE.selected
          : "string",
      search: searchQuery ? searchQuery : "",
      filter: dataSorting,
    };
    paginationPageChange(1);
    fetchClusterUserData(data, 1, activeTab);
  }, [languages]);

  return (
    <>
      <div className="InternalManagement">
        <div className="dashboard-top">
          <div className="dashboard-heading">
            {Globals.INTERNAL_MANAGEMENT.INTERNAL_MANAGEMENT_TEXT}
          </div>
          <div className="internal_management_btns">
            <Button
              optionalTitle={"+"}
              title={Globals.INTERNAL.NEWCLUSTER}
              additionalStyle={"new-cluster"}
              id={"Create_New_Cluster"}
              action={() => {
                navigate(Globals.NAVPATH.ADD_CLUSTER, {
                  state: { activeHeader: selectedTab },
                });
              }}
            />
            <Button
              optionalTitle={"+"}
              title={Globals.INTERNAL.NEWUSER}
              additionalStyle={"new-user"}
              id={"Create_New_User"}
              action={() => {
                navigate(Globals.NAVPATH.ADD_NEW_USER, { state: { activeHeader: selectedTab } })
              }}
            />
          </div>
        </div>
        <div className="InternalManagement-content-box">
          <div className="InternalManagement-overview-tabs">
            <div className="active-inactive-tabs">
              <div
                className={`InternalManagement-overview-tab ${activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
                    ? "active"
                    : ""
                  }`}
                onClick={() =>
                  handleTabClick(OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT)
                }
              >
                {Globals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT}
              </div>
              <div
                className={`InternalManagement-overview-tab ${activeTab === OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT
                    ? "active"
                    : ""
                  }`}
                onClick={() =>
                  handleTabClick(OldGlobals.INTERNAL_MANAGEMENT.USER_MANAGEMENT)
                }
              >
                {Globals.INTERNAL_MANAGEMENT.USER_MANAGEMENT}
              </div>
            </div>
            <div className="InternalManagement-top-seperater"></div>
          </div>

          <div className="filters">
            <div className="results">
              {totalCount} {""}
              {activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
                ? Globals.INTERNAL_MANAGEMENT.RESULTS_CLUSTERS
                : Globals.INTERNAL_MANAGEMENT.RESULTS_USERS}
            </div>
            <div className="row_spearator"></div>
            <div className="filterHeading">{Globals.PRODUCER.FILTERBY}</div>

            {activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT && (
              <CheckboxDropDown
                isOpen={activeDropdown === "REGION"}
                options={dropdownState.dropdowns.REGION.options}
                onToggle={() => handletog("REGION")}
                onSelectAll={(selectAll, options) =>
                  handleSelectAll("REGION", selectAll, options)
                }
                isDatePicker={false}
                onSelect={(value) => {
                  handleSelect("REGION", value);
                }}
                selectedValues={dropdownState.dropdowns.REGION.selected}
                title={Globals.INTERNAL_MANAGEMENT.REGION}
                dropdownRef={(el) => (dropdownRefs.current["Region"] = el)}
                selectedItems={dropdownState.dropdowns.REGION.selectedText}
              />
            )}

            {activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT && (
              <CheckboxDropDown
                isOpen={activeDropdown === "GENRE"}
                options={dropdownState.dropdowns.GENRE.options}
                onToggle={() => handletog("GENRE")}
                onSelectAll={(selectAll, options) =>
                  handleSelectAll("GENRE", selectAll, options)
                }
                onSelect={(value) => handleSelect("GENRE", value)}
                title={Globals.INTERNAL_MANAGEMENT.GENRE}
                isDatePicker={false}
                isCreatedBy={false}
                selectedValues={dropdownState.dropdowns.GENRE.selected}
                dropdownRef={(el) => (dropdownRefs.current["Genre"] = el)}
                selectedItems={dropdownState.dropdowns.GENRE.selectedText}
              />
            )}

            <CheckboxDropDown
              isOpen={activeDropdown === "DATE"}
              options={dropdownState.dropdowns.DATE.options}
              onToggle={() => handletog("DATE")}
              onSelectAll={(selectAll) => handleSelectAll("DATE", selectAll)}
              onSelect={(value) => handleSelect("DATE", value)}
              title={
                activeTab === Globals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
                  ? Globals.INTERNAL_MANAGEMENT.CREATION_DATE
                  : Globals.INTERNAL_MANAGEMENT.REGISTRATION_DATE
              }
              isDatePicker={true}
              selectedValues={dropdownState.dropdowns.DATE.selected}
              selectedMonthYear={dropdownState.dropdowns.DATE.selectedMonthYear}
              selectedMonthYearText={dropdownState.dropdowns.DATE.selectedText}
              dropdownRef={(el) => (dropdownRefs.current["Date"] = el)}
              onDateChange={(date) => handleDateChange("DATE", date)}
              zIndex={2}
            />

            <div
              className={enableClearAll ? "clear clearAllEnable" : "clear"}
              onClick={() => handleClearAll()}
            >
              {Globals.PRODUCER.CLEARALL}
            </div>
            <div className="search">
              <Search
                onSearch={handleSearch}
                searchedFor={searchQuery}
                placeholder={
                  activeTab === OldGlobals.INTERNAL_MANAGEMENT.CLUSTER_MANAGEMENT
                    ? Globals.INTERNAL.SEARCHCLUSTER
                    : Globals.INTERNAL.SEARCHUSER
                }
              />
            </div>
          </div>

          <div className="Table_data">
            {clusterUserData && clusterUserData.length > 0 ? (
              <Table
                data={clusterUserData}
                onSort={handleSorting}
                onDelete={{ openPopup, openPopupuser }}
                navigate={navigate}
                selectedTab={selectedTab}
                sortKey={dataSorting}
              />
            ) : clusterUserDataStatus && clusterUserDataStatus.length > 0 ? (
              <div className="no-data">
                <NoResultsComponent
                  data={{
                    message:
                      dropdownselected ||
                        (searchQuery && searchQuery.length > 0)
                        ? Globals.NO_RESULTS_MESSAGE
                        : Globals.NO_DATA_WITHOUTFILTER,
                    img:
                      dropdownselected ||
                        (searchQuery && searchQuery.length > 0)
                        ? OldGlobals.NO_RESULTS_IMG
                        : OldGlobals.NO_DATA_FOUND_IMG,
                    submessage:
                      dropdownselected ||
                        (searchQuery && searchQuery.length > 0)
                        ? Globals.NO_RESULTS_SUBMESSAGE
                        : "",
                  }}
                />
              </div>
            ) : (
              <div>
                <Loader
                  height={50}
                  width={50}
                  component={"InternalManagement"}
                />
              </div>
            )}
          </div>
          <div className="pagination-container">
            {clusterUserData && clusterUserData.length > 0 ? (
              <Pagination
                totalPages={Math.ceil(
                  totalCount / Globals.MAX_COUNT.TABLE_DATA_COUNT
                )}
                currentPage={currentPage}
                onPageChange={onPageChange}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      {Popup.open && (
        <PopUp
          title={Popup.title}
          text={Popup.promptText}
          onClose={closePopup}
          {...(Popup.negativeActionText && {
            negativeAction: () => {
              deleteCluster(Popup.clusterId);
            },
            negativeActionText: Popup.negativeActionText,
          })}
          {...(Popup.normalActionText && {
            normalAction: () => {
              deleteCluster(Popup.clusterId);
            },
            normalActionText: Popup.normalActionText,
          })}
          disable={Popup.isDisabled}
        />
      )}
      {toast.open && (
        <Toast
          status={toast.status}
          onClose={() => {
            setToast({ open: false, status: "", title: "" });
          }}
          title={toast.title}
        />
      )}
      {userPopup.open && (
        <PopUp
          title={userPopup.title}
          text={userPopup.promptText}
          onClose={closePopupuser}
          negativeAction={() => {
            deleteUser(userPopup.UserID)
          }}
          negativeActionText={userPopup.negativeActionText}
        />
      )}
    </>
  );
};

export default InternalManagement;
